import type { ReactNode } from 'react'
import { Icon, type IconName } from './Icon'
import styles from './Caution.module.css'

/** User-facing warning box (not the dev-only ApiNote, which we don't build). */
export function Caution({ icon = 'shield', children }: { icon?: IconName; children: ReactNode }) {
  return (
    <div className={styles.caution} role="note">
      <Icon name={icon} size={18} className={styles.icon} />
      <span className={styles.text}>{children}</span>
    </div>
  )
}
